import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

/**
 * Auto-discovers an account's email-provider configuration from a sample email address — the
 * react-query replacement for the legacy `AutoDiscoverEmailViewModel.loadSuggestedEmailProvider()`.
 * `POST admin/account/suggestedEmailProvider?email=`. This is an admin-scoped endpoint (not
 * impersonation-scoped), so it is called directly like `useDefaultEmailConfigurationMutation`.
 * `callAsync` throws on a non-success result, so callers surface the failure via `error`/`isError`.
 */
export function useAutoDiscoverEmailMutation() {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ email }: { email: string }) =>
			userSession.webServiceHelper.callAsync<Api.IEmailProviderConfiguration>(
				`admin/account/suggestedEmailProvider?email=${encodeURIComponent(email)}`,
				'POST',
				{}
			),
	});
}
